import store from 'store';
import { authorizeHeader } from '../utils/auth-header'
import { PATIENT_API_BASE_URL, AUTH0_PATIENT_ENDPOINT_SUFFIX, PHYSICIAN_ENDPOINT, ATTACHMENT_ENDPOINT_SUFFIX, ANONYMOUS_PATIENT_ENDPOINT_SUFFIX } from '../config/api-endpoints'
import { LOCAL_STORAGE_AUTH_KEY } from '../config/constants'
import AuthService from '../services/AuthService'

// eslint-disable-next-line import/prefer-default-export
export const postPatientAPICall = async (data) => {
  let dataBody = {}

  if (data && data.name !== undefined) {
    dataBody = data
  }

  try {
    const config = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(dataBody)
    }
    const endpointToHit = PATIENT_API_BASE_URL
    const response = await window.fetch(endpointToHit, config)
    const responseOk = await response.status === 201
    const responseJSON = await response.json()
    return { responseOk, responseJSON }

  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('ERROR: ', e)
    return e
  }
}

export const putPatienAPICall = async (data) => {
  const guestId = store.get(LOCAL_STORAGE_AUTH_KEY.GUEST_ID);
  try {
    const config = {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    }
    const endpointToHit = `${PATIENT_API_BASE_URL + guestId}/`
    const response = await window.fetch(endpointToHit, authorizeHeader(config))
    const responseOk = await response.status === 200
    const responseJSON = await response.json()
    return { responseOk, responseJSON }

  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('ERROR: ', e)
    return e
  }
}

export const getPatienDetailAPICall = async (guestId) => {
  try {
    const config = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    }
    const endpointToHit = `${PATIENT_API_BASE_URL + guestId}/`
    const response = await window.fetch(endpointToHit, authorizeHeader(config))
    const responseOk = await response.status === 200
    const responseJSON = await response.json()
    return { responseOk, responseJSON }

  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('ERROR: ', e)
    return e
  }
}

export const putPatienAnonymousAPICall = async (data) => {
  const guestId = store.get(LOCAL_STORAGE_AUTH_KEY.GUEST_ID);
  try {
    const config = {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    }
    const endpointToHit = PATIENT_API_BASE_URL + guestId + ANONYMOUS_PATIENT_ENDPOINT_SUFFIX
    const response = await window.fetch(endpointToHit, config)
    const responseOk = await response.status === 200
    const responseJSON = await response.json()
    return { responseOk, responseJSON }

  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('ERROR: ', e)
    return e
  }
}

export const putPatientAuth0APICall = async (data) => {
  const guestId = store.get(LOCAL_STORAGE_AUTH_KEY.GUEST_ID);
  try {
    const config = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    }
    const endpointToHit = PATIENT_API_BASE_URL + guestId + AUTH0_PATIENT_ENDPOINT_SUFFIX
    const response = await window.fetch(endpointToHit, config)
    const responseOk = await response.status === 201 || await response.status === 200
    const responseJSON = await response.json()
    return { responseOk, responseJSON }

  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('ERROR: ', e)
    return e
  }
}

export const getPhysicianAPICall = async () => {
  try {
    const config = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    }
    const endpointToHit = PHYSICIAN_ENDPOINT
    const response = await window.fetch(endpointToHit, authorizeHeader(config))
    const responseOk = await response.status === 200
    const responseJSON = await response.json()
    return { responseOk, responseJSON }

  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('ERROR: ', e)
    return e
  }
}

export const postSendDoctorAttachmentAPICall = async (data) => {
  try {
    const auth = new AuthService()
    const profile = auth.getUserProfile()
    const { guid } = profile
    const formData = new FormData();
    formData.append('file', data.file, data.file.name);
    formData.append('physician_guid', data.physician_guid);
    formData.append('type', data.type);
    const config = {
      method: 'POST',
      body: formData
    }
    const endpointToHit = PATIENT_API_BASE_URL + guid + ATTACHMENT_ENDPOINT_SUFFIX
    const response = await window.fetch(endpointToHit, authorizeHeader(config))
    const responseOk = await response.status === 201 || await response.status === 200
    const responseJSON = await response.json()
    return { responseOk, responseJSON }

  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('ERROR: ', e)
    return e
  }
}